var map = {
	"./celestial-gate.jpg": "01d3",
	"./cirasia.jpg": "6bf8",
	"./hags-hovel.jpg": "49e6",
	"./jungle-temple.jpg": "bccd",
	"./mountain-arena.jpg": "c465",
	"./northern-star.jpg": "b090",
	"./orbea.jpg": "aa11",
	"./titanfall.jpg": "b3eb",
	"./vapore.jpg": "af2b",
	"./volcano.jpg": "5bf8",
	"./whiterun.png": "7d03",
	"./windfall.jpg": "deca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6b6a";